/**
 * Created by pandemio on 9/20/18.
 */
import React from 'react';
import { Col, Card, CardBody, CardHeader, Container, Row } from 'reactstrap';
import { Spring } from 'react-spring'
import { TimingAnimation, Easing } from 'react-spring/dist/addons'

/** Multiple Language imports **/
import { withLocalize } from "react-localize-redux";
import { renderToStaticMarkup } from 'react-dom/server'; // Fix by the author. Do not remove even if it's not resolved
import { Translate } from "react-localize-redux";
import global from "../../translations/global.json"
/** End of Multiple Language imports **/

import ApiCalls from "../../custom-classes/api-calls";
import SelectorStudent from "../selectors/selector-student";
import LanguageManager from '../../custom-classes/language-manager';
import SelectorStudentProduct from "../selectors/selector-student-products";
import ChartAverage from '../charts/chart-average';
import TableTotalLessons from '../tables/table-total-lessons';
import NavbarMobile from '../navbar/navbar-mobile';
/**
 * Class/component of the student average
 */
class ReportStudentAverage extends React.Component{

    constructor(props){
        // Super is always called when defining the constructor of a subclass
        // All React component classes that have a constructor, should start it with a super(props) call.
        super(props);

        let languages = [
            { name: "English", code: "en" },
            { name: "Español", code: "es" }
        ];

        // To support language library add the following lines
        this.props.initialize({
            languages,
            options: { renderToStaticMarkup, defaultLanguage: LanguageManager.getLanguage("en") }
        });
        this.props.addTranslation(global);

        this.state = {
            productId: null,
            studentId: null,
            languages: languages, // Repeat language here, because we need it to pass it the child to create inline translation
            passedTotal: 0,
            notPassedTotal: 0,
            lessonAverageCompleteInfo: []
        };
    }

    /**
     * Call the user details to set everything
     */
    callStudentAnalysis = () => (newValue) =>{
        this.setState({productId: newValue}, ()=>
        {
            // Call the api of student average
            let apiCall = ApiCalls.getStudentAverage(this.state.studentId.value, this.state.productId.value);
            apiCall.then((data)=>{
                let passedTotal = 0;
                let notPassedTotal = 0;
                if(data.AverageWithLessonResultDetails != null)
                {
                    passedTotal = parseFloat(data.AverageWithLessonResultDetails.Average);
                    notPassedTotal = parseFloat(100 - parseFloat(data.AverageWithLessonResultDetails.Average)).toFixed(2);
                }
                this.setState({
                        passedTotal: passedTotal,
                        notPassedTotal: notPassedTotal,
                        lessonAverageCompleteInfo: data.LessonAverageCompleteInfoResponseList
                    });
            });
        });
    };

    /**
     * Call the student classes
     */
    callStudentProducts = () => (newValue) => {
        this.setState({studentId: newValue});
    };

    /**
     * Render the form details
     * @returns {XML}
     */
    render() {
        return(
            <div>
                <NavbarMobile/>
                <Spring from={{opacity: 0}} to={{opacity: 1}} impl={TimingAnimation} config={{duration:450, easing: Easing.linear}}>
                    {
                        styles =>
                            <Container>
                                <Row>
                                <Col sm={{size: 12, offset: 0}} lg={{size:12, offset: 0}} style={styles}>
                                    <Card className="card-white">
                                        <CardHeader className="card-cyan">
                                            <h4 className="white-text">
                                                <Translate id="report-student-average.student-average" options={{renderInnerHtml: false}}/>
                                            </h4>
                                            <small>
                                                <Translate id="report-student-average.student-average-instructions" options={{renderInnerHtml: false}}/>
                                            </small>
                                        </CardHeader>
                                        <CardBody>
                                            <Row>
                                                <Col sm={{size:12}} md={{size:6}} lg={{size:6}}>
                                                    <p><b><Translate id="report-student-average.select-student" options={{renderInnerHtml: true}}/></b></p>
                                                    <SelectorStudent updateParent={this.callStudentProducts()}  />
                                                </Col>
                                                <Col sm={{size:12}} md={{size:6}} lg={{size:6}}>
                                                    <p><b><Translate id="report-student-average.select-class" options={{renderInnerHtml: true}}/></b></p>
                                                    { this.state.studentId !== null ?
                                                        <SelectorStudentProduct data={this.state} updateParent={this.callStudentAnalysis()} /> : null }
                                                </Col>
                                            </Row>
                                        </CardBody>
                                    </Card>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col lg={{size:12}} md={{size:12}} sm={{size:12}}>
                                        {
                                         this.state.passedTotal !== 0
                                        && this.state.notPassedTotal !== 0 ?
                                        <Card className="card-white">
                                            <CardHeader className="card-orange">
                                                <h4 className="white-text">
                                                    <Translate id="report-student-average.student-average" options={{renderInnerHtml: false}}/>
                                                </h4>
                                            </CardHeader>
                                            <CardBody>
                                                <Row>
                                                    <Col sm={{size:12}} md={{size:12}} lg={{size:12}}>
                                                        { this.state.studentId !== null
                                                        && this.state.productId !== null
                                                        && this.state.passedTotal !== 0
                                                        && this.state.notPassedTotal !== 0 ?
                                                            <ChartAverage data={this.state} updateParent={this.callStudentAnalysis()} /> : null }
                                                    </Col>
                                                </Row>
                                            </CardBody>
                                        </Card>
                                            : null }
                                    </Col>

                                </Row>
                                <Row>
                                    <Col lg={{size:12}} md={{size:12}} sm={{size:12}}>
                                        <Card className="card-white">
                                            <CardHeader className="card-red">
                                                <h4 className="white-text">
                                                    <Translate id="report-student-average.average-lesson" options={{renderInnerHtml: false}}/>
                                                </h4>
                                            </CardHeader>
                                            <CardBody>
                                                <Row>
                                                    <Col sm={{size:12}} md={{size:12}} lg={{size:12}}>
                                                        {
                                                            this.state.lessonAverageCompleteInfo !== null &&
                                                        this.state.lessonAverageCompleteInfo.length > 0 ?
                                                            <TableTotalLessons data={this.state} /> : null }
                                                    </Col>
                                                </Row>
                                            </CardBody>
                                        </Card>
                                    </Col>
                                </Row>
                            </Container>
                    }
                </Spring>
            </div>
        )
    };
}

export default withLocalize(ReportStudentAverage);


// WEBPACK FOOTER //
// ./src/components/reports/report-student-average.js